import { createEvent } from './_helpers'

const activeClass = 'active'
const openClass = 'open'

export default class Dropdown {
  constructor(el) {
    this.dropdownEl = el
    this.dropdownSelectionEl = el.querySelector('[data-dropdown-selection]')
    this.dropdownSelectionContent = this.dropdownSelectionEl.querySelector(
      'span'
    )
    this.searchParams = new URLSearchParams(window.location.search)
    this.dropdownOptionsEl = el.querySelector('[data-dropdown-options]')
    this.dropdownOptionsList = el.querySelectorAll('[data-dropdown-option]')
    this.firstActiveOption = [...this.dropdownOptionsList].find(opt =>
      opt.querySelector('input').hasAttribute('checked')
    )
    this.submitFormOnChange = this.dropdownEl.hasAttribute(
      'data-submit-on-change'
    )
    this.closestForm = this.dropdownEl.closest('form')

    this.init()
  }

  removeActiveFromAll() {
    this.dropdownOptionsList.forEach(el => el.classList.remove(activeClass))
  }

  addClass(el, className) {
    el.classList.add(className)
  }

  removeClass(el, className) {
    el.classList.remove(className)
  }

  toggleClass(el, className) {
    el.classList.toggle(className)
  }

  addSelection(el) {
    this.dropdownSelectionContent.innerText = el.dataset.dropdownOption
  }

  init() {
    this.dropdownOptionsList.forEach(opt => {
      opt.addEventListener('click', () => {
        if (this.submitFormOnChange) {
          this.closestForm.dispatchEvent(createEvent('submit'))
          this.removeClass(this.dropdownEl, openClass)
        }
      })
    })

    this.dropdownSelectionEl.addEventListener('click', () => {
      this.toggleClass(this.dropdownEl, openClass)
    })

    document.addEventListener('click', e => {
      if (this.dropdownEl && !this.dropdownEl.contains(e.target)) {
        this.removeClass(this.dropdownEl, openClass)
      }
    })
  }
}
